import { PatientHistoryType } from 'src/graphql.generated'

export type PatientHistoryFormType = PatientHistoryType | 'FINANCIAL_ELIGIBILITY_HEALTH_PLAN'

export const PATIENT_HISTORY_TYPE_NAMES: Record<PatientHistoryFormType, string> = {
  ACCEPTED: 'Participant Accepted',
  ANONYMOUS_NOTE: 'Anonymous Notes for Analytics',
  BURNOUT: 'Burnout Questionnaire',
  CHECK_IN_CALL: 'Check-in Call',
  CUSTOM: 'Form Submission',
  DECLINED: 'Participant Declined',
  DISCHARGE_SUMMARY_NOTE: 'Discharge Summary Note',
  FINANCIAL_ELIGIBILITY_CONFIRMED: 'Financial Eligibility Confirmed',
  MONTHLY_SUMMARY_NOTE: 'Monthly Summary Note',
  FINANCIAL_ELIGIBILITY_HEALTH_PLAN: 'Financial Eligibility Health Plan',
  GAD7: 'GAD-7',
  INTAKE_NOTE: 'Intake Notes',
  INTAKE_NOTE_COACHING: 'Intake Notes (Coaching)',
  INTAKE_NOTE_PSYCHIATRY: 'Intake Notes (Psychiatry)',
  INTAKE_NOTE_COMPREHENSIVE: 'Intake Notes',
  MISSED_INTAKE_CALL: 'Missed Intake Call',
  NOTE: 'Note',
  PARTICIPANT_RE_ENROLLED: 'Participant Re-enrolled',
  PHONE_CALL: 'Phone Call',
  PHQ9: 'PHQ-9',
  PROGRAM_END: 'Program End',
  SMS: 'SMS',
  WPAI: 'WPAI',
  WHO5: 'WHO-5',
  PSS4: 'PSS-4',
  BRS: 'BRS',
  TREATMENT_PLAN: 'Treatment Plan',
  TREATMENT_PLAN_COMPREHENSIVE: 'Treatment Plan',
  TREATMENT_PLAN_COMPREHENSIVE_UPDATE: 'Treatment Plan Update',
  VIDEO_CALL: 'Check-in Call',
  LAB_ORDER: 'Lab',
  LAB_ORDER_NOTE: 'Lab',
  ADVANCED_FOLLOW_UP_NOTE: 'Meru Advanced Follow Up Note',
  PCL5: 'PCL-5',
  ASRM: 'ASRM',
  OCIR: 'OCI-R',
  ISI: 'ISI',
} as const

export const INTAKE_NOTE_TYPES = [
  PatientHistoryType.IntakeNote,
  PatientHistoryType.IntakeNoteCoaching,
  PatientHistoryType.IntakeNotePsychiatry,
  PatientHistoryType.IntakeNoteComprehensive,
] as const

export const MISSED_INTAKE_CALL_REASONS = {
  PATIENT_DID_NOT_SHOW_UP: 'Participant did not show up',
  PATIENT_CANCELLED: 'Participant cancelled < 24h before',
} as const

export const DEFAULT_INTAKE_NOTE_TTL_IN_HOURS = 24 * 2
